import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@design-system';
import { AddPartnerDialog, LinkExistingPartnerDialog } from '@/features/add-partner';

import { useSelector } from 'react-redux';
import { isNullOrUndefined, SessionType } from '@shared';
import {
  selectClient,
  selectClients,
  selectMaybeClientPartner,
  selectSession,
} from '@client/model/selectors';

type SendPartnerLinkRequestModalProps = {
  open: boolean;
  onClose: () => void;
};

export function SendPartnerLinkRequestModal({ open, onClose }: SendPartnerLinkRequestModalProps) {
  const client = useSelector(selectClient);
  const { clientId, clientFullName } = client;

  const clients = useSelector(selectClients);
  const clientPartner = useSelector(selectMaybeClientPartner);

  const { sessionType } = useSelector(selectSession);

  if (sessionType === SessionType.advisor || sessionType === SessionType.wizard) {
    if (clients.length === 0) {
      return (
        <Dialog
          open={open}
          onOpenChange={isOpen => {
            if (!isOpen) onClose();
          }}
        >
          <DialogContent className="max-w-md">
            <DialogHeader>
              <DialogTitle>Link Partner</DialogTitle>
              <DialogDescription />
            </DialogHeader>
            <p className="text-foreground py-4 text-base">
              As an advisor, you can create or edit partner links directly from your client's
              dashboard. No request or approval needed.
            </p>
          </DialogContent>
        </Dialog>
      );
    }

    return (
      <LinkExistingPartnerDialog
        open={open}
        client={client}
        onClose={onClose}
      />
    );
  }

  if (!isNullOrUndefined(clientPartner)) {
    return (
      <Dialog
        open={open}
        onOpenChange={isOpen => {
          if (!isOpen) onClose();
        }}
      >
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>Partner</DialogTitle>
            <DialogDescription />
          </DialogHeader>
          <p className="text-foreground py-4 text-base">
            {clientFullName} is currently linked with {clientPartner.clientFullName}. To update
            this, please reach out to your advisor.
          </p>
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <AddPartnerDialog
      open={open}
      onOpenChange={isOpen => {
        if (!isOpen) onClose();
      }}
      clientId={clientId}
      onSubmitSuccess={onClose}
    />
  );
}
